import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikErrors, useFormik } from 'formik'

import { EInvoiceConfig } from '../../data'
import { FormValues } from './EInvoice.data'
import { EInvoiceView } from './EInvoice.view'

type Props = {
  data: EInvoiceConfig | undefined
  handleSubmit: (formData: FormValues) => Promise<void>
  isRequestRunning: boolean
}

export const EInvoiceDataForm: React.FC<Props> = ({
  data,
  handleSubmit,
  isRequestRunning,
}) => {
  const { t } = useTranslation()

  // formik
  const formik = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      maxFileSize: data?.maxFileSize || 0,
      xIncActive: data?.xInc?.active || false,
      xIncVersion: data?.xInc?.version || '',
      xIncVersionComparer: data?.xInc?.versionComparer || 0,
      zugfActive: data?.zugf?.active || false,
      zugfVersion: data?.zugf?.version || '',
      zugfVersionComparer: data?.zugf?.versionComparer || 0,
    },
    validate: data => {
      let errors: FormikErrors<FormValues> = {}

      // Max file size
      if (data.maxFileSize < 0) {
        errors.maxFileSize = t(
          'buyerSettings.eInvoice.eInvoiceSize.form.maxFileSize.validation.negative',
        )
      } else if (data.maxFileSize === 0) {
        errors.maxFileSize = t(
          'buyerSettings.eInvoice.eInvoiceSize.form.maxFileSize.validation.numberTooSmall',
          { number: 0 },
        )
      } else if (data.maxFileSize > 1000) {
        errors.maxFileSize = t(
          'buyerSettings.eInvoice.eInvoiceSize.form.maxFileSize.validation.numberTooBig',
          { number: 1000 },
        )
      }

      // XRechnung
      if (data.xIncActive) {
        if (
          data.xIncVersionComparer === undefined ||
          data.xIncVersionComparer === null
        ) {
          errors.xIncVersionComparer = t(
            'buyerSettings.eInvoice.eInvoiceFormat.form.xInvoice.versionComparer.validation.selectionRequired',
          )
        }

        if (!data.xIncVersion) {
          errors.xIncVersion = t(
            'buyerSettings.eInvoice.eInvoiceFormat.form.xInvoice.version.validation.selectionRequired',
          )
        }
      }

      // ZUGFeRD
      if (data.zugfActive) {
        if (
          data.zugfVersionComparer === undefined ||
          data.zugfVersionComparer === null
        ) {
          errors.zugfVersionComparer = t(
            'buyerSettings.eInvoice.eInvoiceFormat.form.zugferd.versionComparer.validation.selectionRequired',
          )
        }

        if (!data.zugfVersion) {
          errors.zugfVersion = t(
            'buyerSettings.eInvoice.eInvoiceFormat.form.zugferd.version.validation.selectionRequired',
          )
        }
      }

      // Both formats cannot be inactive at the same time
      if (!data.xIncActive && !data.zugfActive) {
        errors.xIncActive = t(
          'buyerSettings.eInvoice.eInvoiceFormat.form.xInvoice.status.validation.selectionRequired',
        )
        errors.zugfActive = t(
          'buyerSettings.eInvoice.eInvoiceFormat.form.zugferd.status.validation.selectionRequired',
        )
      }

      return errors
    },
    onSubmit: async (formData: FormValues) => {
      handleSubmit(formData)
    },
  })

  return <EInvoiceView formik={formik} isRequestRunning={isRequestRunning} />
}
